"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _fluxActions = require("flux-actions");

var _immutable = require("immutable");

var _actions = require("./actions");

var _constants = require("./constants");

var _handleActions;

var initialState = (0, _immutable.fromJS)({
  enabled: {
    status: _constants.JitaSettings.ENABLED,
    jitaStatusUserInfo: {}
  }
});

var _default = (0, _fluxActions.handleActions)((_handleActions = {}, (0, _defineProperty2.default)(_handleActions, _actions.FetchJitaEnabledActionTypes.SUCCESS, function (state, action) {
  return state.set('enabled', (0, _immutable.fromJS)({
    status: action.payload.data.status,
    jitaStatusUserInfo: action.payload.data.jitaStatusUserInfo || {}
  }));
}), (0, _defineProperty2.default)(_handleActions, _actions.SetJitaDisabledActionTypes.SUCCESS, function (state, action) {
  return state.set('enabled', (0, _immutable.fromJS)({
    status: action.payload.data.status,
    jitaStatusUserInfo: action.payload.data.jitaStatusUserInfo || {}
  }));
}), (0, _defineProperty2.default)(_handleActions, _actions.SetJitaEnabledActionTypes.SUCCESS, function (state, action) {
  return state.set('enabled', (0, _immutable.fromJS)({
    status: action.payload.data.status,
    jitaStatusUserInfo: action.payload.data.jitaStatusUserInfo || {}
  }));
}), _handleActions), initialState);

exports.default = _default;
module.exports = exports.default;